import { ENTITY_TYPES } from '@sales-center/common'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { ICustomFieldFormSetting } from '../entityFormSettings'

import { ServiceConfig } from '../services/config'
import { APIReject, APIError, get, put } from '../services/crud'
import {
  CustomFieldSettingOrderInput,
  CustomFieldSettingUpdate,
} from './typings'

const baseUrl = `${ServiceConfig.baseAPIUrl}${ServiceConfig.customFields.customFields}`

export const getAllCustomFieldsSettings = createAsyncThunk<
  ICustomFieldFormSetting[],
  ENTITY_TYPES,
  { rejectValue: APIError }
>('customFieldsSettings/getAll', async (entityType: ENTITY_TYPES, thunkApi) => {
  const response = await get(
    `${baseUrl}${
      entityType == ENTITY_TYPES.Lead
        ? ServiceConfig.customFields.leadFormSettings
        : ServiceConfig.customFields.opportunityFormSettings
    }`,
  )
  if (response.ok) return await response.json()
  return thunkApi.rejectWithValue(await response.json())
})

export const toggleCustomFieldRequired = createAsyncThunk<
  CustomFieldSettingUpdate,
  CustomFieldSettingUpdate,
  { rejectValue: APIReject }
>('customFieldsSettings/toggleRequired', async (data, thunkApi) => {
  const response = await put(
    `${baseUrl}${ServiceConfig.customFields.toggleFormSettingRequired}`,
    data,
  )
  if (!response.ok) return thunkApi.rejectWithValue(await response.json())
  else return data
})

export const toggleCustomFieldEnabled = createAsyncThunk<
  CustomFieldSettingUpdate,
  CustomFieldSettingUpdate,
  { rejectValue: APIReject }
>('customFieldsSettings/toggleEnabled', async (data, thunkApi) => {
  const response = await put(
    `${baseUrl}${ServiceConfig.customFields.toggleFormSettingEnabled}`,
    data,
  )
  if (!response.ok) return thunkApi.rejectWithValue(await response.json())
  else return data
})

export const reorderCustomFieldSettings = createAsyncThunk<
  void,
  CustomFieldSettingOrderInput,
  { rejectValue: APIReject }
>('customFieldsSettings/reorder', async (data, thunkApi) => {
  const response = await put(
    `${baseUrl}${ServiceConfig.customFields.reorderFormSettings}`,
    data,
  )
  if (!response.ok) return thunkApi.rejectWithValue(await response.json())
})
